(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/ball-rows-collapsible/assets/javascripts/ball-rows-collapsible.js') >= 0) return;  svs.modules.push('/components/tur/ball-rows-collapsible/assets/javascripts/ball-rows-collapsible.js');
'use strict';

svs.tur = svs.tur || {};
svs.tur.ball = svs.tur.ball || {};
svs.tur.ball.rows = svs.tur.ball.rows || {};
svs.tur.ball.rows.collapsible = svs.tur.ball.rows.collapsible || {};


class Collapsible extends svs.tur.ball.rows.Default {
  constructor(_ref) {
    let {
      collapseAt = 3,
      rows = [],
      lazyRender = false
    } = _ref;
    super({
      rows,
      className: 'ball-rows-collapsible'
    });
    this.collapseAt = collapseAt;
    this._collapsedHeight = 0;
    this._lazyRender = lazyRender;
  }
  classNames() {
    return ['ball-rows-collapsible-default', 'ball-rows'];
  }
  render() {
    let visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    try {
      if (!visible) {
        this.$el.style.opacity = 0;
      }
      let length = this.rows.length;
      if (this._lazyRender) {
        length = Math.min(this.collapseAt, length);
        this._isLazilyRendered = true;
      }
      const fragment = document.createDocumentFragment();
      for (let i = 0; i < length; i++) {
        fragment.appendChild(this.rows[i].render(visible));
      }
      this.$el.appendChild(fragment);
      this.$el.style.visibility = 'hidden';
      return this.$el;
    } finally {
      setTimeout(() => {
        this.afterRender();
      }, 0);
    }
  }
  afterRender() {
    if (this.rows.length > this.collapseAt) {
      this.$el.className += ' ball-rows-collapsed';
      if (this._lazyRender) {
        this._expandedHeight = 'auto';
      } else {
        this._expandedHeight = this.getAbsoluteHeight(this.$el);
      }
      _.first(this.rows, this.collapseAt).forEach(row => {
        this._collapsedHeight += this.getAbsoluteHeight(row.$el);
      });
      this.collapse(true);
    }
    this.$el.style.visibility = 'visible';
  }
  collapse() {
    let instant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    const tl = gsap.timeline();
    if (!this._collapsed) {
      this._collapsed = true;
      const duration = instant ? 0 : 1;
      tl.to(this.$el, {
        duration,
        height: this._collapsedHeight,
        onComplete: () => this.trigger(svs.tur.ball.constants.COLLAPSE_COMPLETED)
      });
    }
    return tl;
  }
  expand() {
    let instant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (this._isLazilyRendered) {
      this._isLazilyRendered = false;
      const fragment = document.createDocumentFragment();
      for (let i = this.collapseAt, len = this.rows.length; i < len; i++) {
        fragment.appendChild(this.rows[i].render());
      }
      this.$el.appendChild(fragment);
    }
    const tl = gsap.timeline();
    if (this._collapsed) {
      this._collapsed = false;
      if (!instant) {
        tl.to(this.$el, {
          duration: 1,
          height: this._expandedHeight,
          onComplete: () => this.trigger(svs.tur.ball.constants.EXPAND_COMPLETED)
        });
      }
    }
    return tl;
  }
}
svs.tur.ball.rows.collapsible.Default = Collapsible;

 })(window);